import { AppDeleteIcon } from 'shared/UI/UIKit/icons/Delete';
import { AppEditIcon } from 'shared/UI/UIKit/icons/Edit';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppButton } from 'shared/UI/UIKit/Button';
import { AppCopyIcon } from 'shared/UI/UIKit/icons/Copy';
import type { AppTableColumn } from 'shared/UI/UIKit/Table';
import type {
  ScheduleConfiguration,
  ScheduleConfigurationStatus,
} from 'services/api/schedule-configuration/types';
import styles from '../ui/styles.module.scss';
import { getStatusTag } from './utils';

interface ColumnsProps {
  handlePublishConfiguration: (id: number) => void;
  handleViewConfiguration: (id: number) => void;
  handleDeleteConfiguration: (id: number) => void;
  handleCopyConfiguration: (id: number) => void;
}

export const getColumns = ({
  handlePublishConfiguration,
  handleViewConfiguration,
  handleDeleteConfiguration,
  handleCopyConfiguration,
}: ColumnsProps): AppTableColumn<ScheduleConfiguration>[] => {
  return [
    {
      key: 'id',
      title: 'ID',
      dataIndex: ['id'],
      maxWidth: '50px',
    },
    {
      key: 'name',
      title: 'Название',
      dataIndex: ['name'],
    },
    {
      key: 'status',
      title: 'Статус',
      dataIndex: ['status'],
      maxWidth: '150px',
      align: 'center',
      render: (status: ScheduleConfigurationStatus) => getStatusTag(status),
    },
    {
      key: 'controls',
      title: '',
      dataIndex: [],
      maxWidth: '300px',
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      render: (_: any, record: ScheduleConfiguration) => (
        <AppFlex direction="row" alignItems="center">
          {record.status === 'DRAFT' ? (
            <>
              <AppButton
                onClick={(e) => {
                  e.stopPropagation();
                  handlePublishConfiguration(record.id);
                }}
              >
                Опубликовать
              </AppButton>
              <AppEditIcon
                className={styles.icon}
                onClick={(e) => {
                  e.stopPropagation();
                  handleViewConfiguration(record.id);
                }}
              />
              <AppDeleteIcon
                className={styles.icon}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteConfiguration(record.id);
                }}
              />
            </>
          ) : (
            <AppButton
              onClick={(e) => {
                e.stopPropagation();
                handleViewConfiguration(record.id);
              }}
            >
              Просмотр
            </AppButton>
          )}
          <AppCopyIcon
            className={styles.icon}
            onClick={(e) => {
              e.stopPropagation();
              handleCopyConfiguration(record.id);
            }}
          />
        </AppFlex>
      ),
    },
  ];
};
